<template>
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g id="Question-Help-Circle--Streamline-Ultimate.svg">
            <rect width="16" height="16" rx="8" fill="#FF7708"/>
            <path id="Vector" d="M5.5 6.49464C5.49931 6.02292 5.63202 5.56062 5.88282 5.1611C6.13361 4.76157 6.49226 4.44111 6.9174 4.23669C7.34254 4.03227 7.8168 3.95223 8.28547 4.00581C8.75414 4.05939 9.19807 4.24441 9.56607 4.5395C9.93414 4.83459 10.2112 5.22774 10.3653 5.67356C10.5195 6.11938 10.5445 6.5997 10.4373 7.05909C10.3301 7.51849 10.0953 7.93823 9.7598 8.26983C9.42434 8.60149 9.00194 8.83149 8.54134 8.93329C8.39027 8.96309 8.254 9.04396 8.1554 9.16229C8.05687 9.28069 8.002 9.42929 8 9.58329V10.3253" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path id="Vector_2" d="M8.00114 12.328C7.90907 12.328 7.83447 12.2534 7.83447 12.1613C7.83447 12.0693 7.90907 11.9946 8.00114 11.9946" stroke="white" stroke-width="1.3"/>
            <path id="Vector_3" d="M8.00146 12.328C8.09353 12.328 8.16813 12.2534 8.16813 12.1613C8.16813 12.0693 8.09353 11.9946 8.00146 11.9946" stroke="white" stroke-width="1.3"/>
        </g>
    </svg>
</template>

<script>
export default {
    name: "IconOrangeQuestionMark"
}
</script>

<style scoped>

</style>
